/** Stable uuid-shaped ids for marketing site demos (not persisted). */

const PREFIX = {
  project: 'd1',
  requirement: 'd2',
  question: 'd3',
  answer: 'd4',
  slack: 'd5',
  team: 'd6',
} as const;

type DemoEntityKind = keyof typeof PREFIX;

export function demoEntityId(kind: DemoEntityKind, index: number): string {
  const hex = index.toString(16).padStart(12, '0');
  return `${PREFIX[kind]}000000-0000-4000-8000-${hex}`;
}

export const DEMO_EXPANDED_PROJECT_ID = demoEntityId('project', 1);
